/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */

/* eslint-disable @typescript-eslint/no-non-null-assertion */
import TextField from 'ageas-react-component-textfield'
import moment from 'moment'

import { usePolicyholderDetailsStore } from '../../Stores/policyholderDetailsStore'
import { t } from '../../i18n'
import {
  OwnerIdentificationContainer,
  StandardContainer,
  UserInfoContainer,
} from './style'

export function OwnerIdentification() {
  const { policyholderDetailsSelected } = usePolicyholderDetailsStore()

  return (
    <OwnerIdentificationContainer>
      <div className="full">
        <TextField
          readOnly
          label={t('pages.step3.owner.NIF')}
          value={policyholderDetailsSelected?.vatNumber}
        />
      </div>
      <StandardContainer>
        <UserInfoContainer>
          <div className="info-container">
            <div className="row">
              <p>{t('table.name')}</p>
              <span>{policyholderDetailsSelected?.name}</span>
            </div>
            <div className="row">
              <p>{t('table.birthday')}</p>
              <span>
                {moment(
                  new Date(policyholderDetailsSelected?.birthdate!),
                ).format('DD-MM-YYYY')}
              </span>
            </div>
          </div>
        </UserInfoContainer>
      </StandardContainer>
    </OwnerIdentificationContainer>
  )
}
